import { render, staticRenderFns } from "./AcceptedOrderModal.vue?vue&type=template&id=3a15e8ed&scoped=true&"
import script from "./AcceptedOrderModal.vue?vue&type=script&lang=js&"
export * from "./AcceptedOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./AcceptedOrderModal.vue?vue&type=style&index=0&id=3a15e8ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a15e8ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VDialog,VMain,VRow})
